import React from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import style from "./Buddies.module.css";
import Container from "../hoc/container/Container";

type ImageSlideProps = {
  heading: string;
  body: string;
  image?: string;
  clicked: () => void;
};

export const ImageSlide = ({
  heading,
  body,
  image,
  clicked,
}: ImageSlideProps) => (
  <div className={style.imageSlide}>
    <img src={image} alt="Testing" />
    <Container justifyContent={true} alignItems={true}>
      <h1>{heading}</h1>
      <p>{body}</p>
      <button onClick={clicked}>SIGN UP</button>
    </Container>
  </div>
);

const Buddies = () => {
  const handleSignUpButtonPressed = () => {};

  return (
    <section className={style.container}>
      <ImageSlide
        heading="Fulfil Together"
        body="Connect with and support the people in your inner circle. 
        This area is about helping family and friends to succeed. "
        clicked={handleSignUpButtonPressed}
      />
    </section>
  );
};

export default Buddies;
